module.exports = __webpack_public_path__ + "static/media/web-light-ic.749d62b6.svg";